import api from "./api.service";

class FilesService {
  async uploadFile(
    file: File,
    colocId: string,
    providerId?: string,
    year?: number
  ): Promise<{ success: boolean; filename: string; message: string; filePath?: string }> {
    const formData = new FormData();
    formData.append("file", file);

    if (providerId) {
      formData.append("providerId", providerId);
    }
    if (year) {
      formData.append("year", year.toString());
    }

    const response = await api.post(`/files/upload/${colocId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }

  async uploadFilesToPending(
    files: File[],
    colocId: string
  ): Promise<{
    success: boolean;
    total: number;
    succeeded: number;
    failed: number;
    results: Array<{ filename: string; success: boolean; error?: string; blobPath?: string }>;
  }> {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));

    const response = await api.post(`/files/${colocId}/upload-to-pending`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }
}

export const filesService = new FilesService();
